import { useWizardOptional } from './WizardProvider';
import type { WizardStep } from './types';

function useActiveWizardStep(): WizardStep | undefined {
  const wizard = useWizardOptional();
  if (!wizard?.activeWizard) {
    return undefined;
  }
  return wizard.activeWizard.steps[wizard.stepIndex ?? 0];
}

/** True when the active step spotlights this `data-wizard-target` id. */
export function useWizardStepTargetActive(targetId: string): boolean {
  const step = useActiveWizardStep();
  return Boolean(targetId && step?.targetId === targetId);
}

/** True when the active step emphasizes this pointer-align target. */
export function useWizardPointerAlignEmphasized(alignTargetId?: string): boolean {
  const step = useActiveWizardStep();
  if (!alignTargetId || !step) {
    return false;
  }
  return (
    step.pointerAlignTargetId === alignTargetId &&
    step.emphasizePointerAlignTarget === true
  );
}
